<template lang="html">

  <div class="grid-x align-middle">
    <div class="cell auto">
      <input type="number" ref="from" :value="modelValue[0]" @change="onChange" @keydown.enter.prevent="" placeholder="От" />
    </div>
    <div class="hyphen cell shrink">&nbsp;-&nbsp;</div>
    <div class="cell auto">
      <input type="number" ref="to" :value="modelValue[1]" @change="onChange" @keydown.enter.prevent="" placeholder="До" />
    </div>
  </div>

</template>

<script>
export default {
}
</script>

<style lang="css">
</style>

<script>
export default {
  model: {
    prop: 'modelValue',
    event: 'input'
  },
  props: {
    modelValue: {
      default: function() {
        return []
      },
    },
  },
  methods: {
    onChange(evt) {
      var model = [
        this.$refs.from.value,
        this.$refs.to.value
      ]
      this.$emit('input', model);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/fromto.vue